import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-marker",
  "use": "map-marker-usage",
  "viewBox": "0 0 33.468 33.468",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33.468 33.468\" id=\"map-marker\"><path d=\"M16.734 0C9.375 0 3.408 5.966 3.408 13.325c0 11.076 13.326 20.143 13.326 20.143S30.06 23.734 30.06 13.324C30.06 5.965 24.093 0 16.734 0zm0 19.676a6.353 6.353 0 1 1 6.352-6.351 6.352 6.352 0 0 1-6.352 6.351z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol